import { Controller } from "@hotwired/stimulus"

// Reloads the named frame (else the page) while the work runs.
export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 }, frame: String, url: String }

  connect() {
    this.timer = setTimeout(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  refresh() {
    const frame = this.frameValue && document.getElementById(this.frameValue)
    if (frame && this.urlValue) {
      if (frame.getAttribute("src") === this.urlValue) frame.reload()
      else frame.src = this.urlValue
    } else if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: "replace" })
    } else {
      window.location.reload()
    }
  }
}
